"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vueTypes = _interopRequireDefault(require("ant-design-vue/es/_util/vue-types"));
var _vuedraggable = _interopRequireDefault(require("vuedraggable"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 仅需要的字段
var itemColumns = ['goods_id', 'goods_name', 'goods_image', 'goods_price_min', 'line_price_min', 'selling_point', 'goods_sales'];

// 商品选择器组件
var _default = exports.default = {
  name: 'SelectGoods',
  components: {
    draggable: _vuedraggable.default
  },
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    // 最大选择的数量限制, multiple模式下有效
    maxNum: _vueTypes.default.integer.def(100),
    // 选中的商品数据
    value: _vueTypes.default.array.def([])
  },
  data: function data() {
    return {
      // 已选择的商品列表
      selectedItems: []
    };
  },
  watch: {
    value: {
      // 首次加载的时候执行函数
      immediate: true,
      handler: function handler(val) {
        this.onUpdate(val);
      }
    }
  },
  created: function created() {},
  methods: {
    // 更新已选择的数据 selectedItems
    onUpdate: function onUpdate(items) {
      this.selectedItems = items;
      this.onChange();
    },
    // 打开商品选择器
    handleSelectGoods: function handleSelectGoods() {
      var _this = this;
      var checked = this.selectedItems.map(function (item) {
        return {
          id: item.goods_id
        };
      });
      this.$modalGoodList(function (rows) {
        var list = Array.isArray(rows) ? rows : [rows];
        _this.onUpdate(_this.filterItems(list));
      }, 'many', checked);
    },
    // 过滤仅需要的数据
    filterItems: function filterItems(selectedItems) {
      return selectedItems.map(function (itm) {
        var row = {
          goods_id: itm.goods_id || itm.id,
          goods_name: itm.goods_name || itm.storeName || '',
          goods_image: itm.goods_image || itm.image || '',
          goods_price_min: itm.goods_price_min || itm.price || 0,
          line_price_min: itm.line_price_min || itm.otPrice || 0,
          selling_point: itm.selling_point || itm.storeInfo || '',
          goods_sales: itm.goods_sales || itm.sales || 0
        };
        return (0, _lodash.pick)(row, itemColumns);
      });
    },
    // 删除商品
    handleDeleteItem: function handleDeleteItem(index) {
      var selectedItems = this.selectedItems;
      if (selectedItems.length <= 1) {
        this.$message.warning('请至少保留1个', 1);
        return;
      }
      selectedItems.splice(index, 1);
      this.onUpdate(selectedItems);
    },
    // 触发change事件
    onChange: function onChange() {
      var selectedItems = this.selectedItems;
      return this.$emit('change', selectedItems);
    }
  }
};